'use client'
import React, { createContext, useContext, useState, useCallback, useRef } from 'react'
import GlobalModal from '@/components/UI/GlobalModal'

const UIContext = createContext()

export const useUI = () => useContext(UIContext)

export const UIProvider = ({ children }) => {
    const [modalConfig, setModalConfig] = useState(null)
    const resolveRef = useRef(null)

    // variant: 'danger' | 'primary' | 'success'
    const showConfirm = useCallback(({ title, message, confirmText = 'Aceptar', cancelText = 'Cancelar', variant = 'danger' }) => {
        return new Promise((resolve) => {
            setModalConfig({
                type: 'confirm',
                title,
                message,
                confirmText,
                cancelText,
                variant
            })
            resolveRef.current = resolve
        })
    }, [])

    // Returns string (input value) or null (if cancelled)
    const showPrompt = useCallback(({ title, message, defaultValue = '', placeholder = '', confirmText = 'Aceptar', cancelText = 'Cancelar', variant = 'primary', multiline = false }) => {
        return new Promise((resolve) => {
            setModalConfig({
                type: 'prompt',
                title,
                message,
                defaultValue,
                placeholder,
                confirmText,
                cancelText,
                variant,
                multiline
            })
            resolveRef.current = resolve
        })
    }, [])

    // Returns { name, template } or null
    const showCreateConfig = useCallback(({ title, confirmText = 'Crear', cancelText = 'Cancelar', defaultValue = '', userConfigs = [] }) => {
        return new Promise((resolve) => {
            setModalConfig({
                type: 'create_config',
                title,
                confirmText,
                cancelText,
                defaultValue,
                userConfigs,
                variant: 'primary'
            })
            resolveRef.current = resolve
        })
    }, [])

    const [isCreateConfigOpen, setIsCreateConfigOpen] = useState(false)

    const handleClose = (result) => {
        setModalConfig(null)
        if (resolveRef.current) {
            resolveRef.current(result)
            resolveRef.current = null
        }
    }

    return (
        <UIContext.Provider value={{ showConfirm, showPrompt, showCreateConfig, isCreateConfigOpen, setIsCreateConfigOpen }}>
            {children}
            <GlobalModal config={modalConfig} onClose={handleClose} />
        </UIContext.Provider>
    )
}
